/* eslint-disable react/jsx-props-no-spreading */
import React, { memo } from 'react';
import { LaunchCode } from '../../utils/launch';
import { createGoURL } from '../../utils/router';
import { Footer as MulliganFooter } from '../../web-shared/design-system/footer/footer';
import {
  PHILO_BLOG_URL,
  PHILO_HELP_URL,
  PHILO_JOBS_URL,
  PHILO_PRESS_URL,
} from '../../web-shared/utils/constants';
import { FooterLink } from './footer-link';
import styles from './footer.module.sass';

const LINK_GROUPS = {
  Browse: {
    'Free Channels': createGoURL(LaunchCode.FAST),
    Channels: createGoURL(LaunchCode.CHANNELS),
    Features: createGoURL(LaunchCode.FEATURES),
    FAQ: createGoURL(LaunchCode.FAQ),
    Devices: createGoURL(LaunchCode.DEVICES),
  },
  About: {
    Blog: PHILO_BLOG_URL,
    Press: PHILO_PRESS_URL,
    Jobs: PHILO_JOBS_URL,
    Help: PHILO_HELP_URL,
  },
};

export const Footer = memo(() => {
  const columns = Object.entries(LINK_GROUPS).map(([title, links]) => ({
    title,
    links: Object.entries(links).map(([label, href]) => (
      <FooterLink key={label} href={href} title={label}>
        {label}
      </FooterLink>
    )),
  }));

  return <MulliganFooter columns={columns} className={styles.footer} linkComponent={FooterLink} />;
});
